/** Default venue contact on asset create until per-venue contact is supported in the UI. */
export const ASSET_CREATE_CONTACT_EMAIL = 'info@offizz.ai';
export const ASSET_CREATE_CONTACT_PHONE = '03-1234567';
